import { ReactElement } from 'react';

import HeaderDefault from '@/components/HeaderDefault';
import HeaderFln from '@/components/HeaderFln';
import { useThemeConfig } from '@/theme/useTheme';

export interface HeaderProperties {
  headerTitle: string;
  children: ReactElement;
  showBack: boolean;
  showCoins?: boolean;
  onBack?: () => void;
  variant?: 'default' | 'stage';
  backLabel?: string;
  levelLabel?: string;
  showStudentCard?: boolean;
}

export default function Header(properties: HeaderProperties) {
  const { layout } = useThemeConfig();
  const View = layout.header === 'fln' ? HeaderFln : HeaderDefault;
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <View {...properties} />;
}
